import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { getTimelineData } from "./data";

export function Timeline() {
  const intl = useIntl();

  const timelineData = getTimelineData({ intl });

  return (
    <Flex w="full" position="relative" flexDir="column" gap="3rem" py="1.5rem">
      <Box
        display={{ base: "none", md: "block" }}
        position="absolute"
        zIndex="0"
        left="50px"
        top="0"
        width="1px"
        height="calc(100% - 4rem)"
        bgColor="brandPrimary.200"
      />

      {timelineData.map((item, index) => (
        <Flex key={index} gap="3rem" flexDir={{ base: "column", md: "row" }}>
          <Flex
            position="relative"
            zIndex="2"
            minW="100px"
            height={{ base: "48px", md: "100px" }}
            border="2px solid"
            borderColor="brandPrimary.400"
            bgColor="white"
            alignItems="center"
            justifyContent="center">
            <Text variant="text-large" textAlign="center">
              {item.dayLabel}
            </Text>
          </Flex>

          <Stack spacing=".75rem">
            <Text variant="h4">{item.title}</Text>

            {item.children}
          </Stack>
        </Flex>
      ))}
    </Flex>
  );
}
